import React from 'react';
import ReactDOM from 'react-dom';

class Modal extends React.Component{
   state={toggle:''}

	OnClose=(event)=>{
		this.setState({toggle:false})
		this.props.onClose(this.state.toggle)
	}
render(props){
	return ReactDOM.createPortal(
		<div className="ui dimmer show modals visible active">
			<div className="ui raised very padded text container segment">
				<h1>Some details about  {this.props.data}</h1>
			</div>
			<button className="ui red button" onClick={this.OnClose} >Close</button>
		</div>,
		document.querySelector('#modal')
		)
}
}

export default Modal;